import { Component, OnDestroy, OnInit } from '@angular/core';
import { ClientService } from '../../shared/client/client.service';
import { filter } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-vt',
  templateUrl: './vt.component.html',
  styleUrls: ['./vt.component.scss']
})
export class VTComponent implements OnInit, OnDestroy {

  subClient

  constructor(private clientService: ClientService, 
    private route: ActivatedRoute, 
    private router: Router) {

  }

  ngOnInit() {
    //redirect if current client is changed
    this.subClient = this.clientService.getCurrentClient().subscribe(client => {
      this.router.navigate(['./'], {
        relativeTo: this.route
      })
    });
  }

  ngOnDestroy(): void {
    if (this.subClient) {
      this.subClient.unsubscribe()
    }
  }
}
